import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { useAuth0 } from "@auth0/auth0-react";
import Cookies from "js-cookie";

import { usePermission } from "hooks/usePermission";
import Redirecting from "components/ui/Layout/Redirecting";
import { GETDANTE_URL } from "constants/navs";

export const PrivateRoutes = ({ showLoading }: { showLoading?: boolean }) => {
  const [accessToken, setAccessToken] = useState<string | null>(null);
  const {
    loginWithRedirect,
    isAuthenticated,
    user,
    isLoading,
    error,
    logout,
    getIdTokenClaims,
  } = useAuth0();
  const {
    data: roleData,
    refetch: roleRefetch,
    isFetching: roleIsFetching,
  } = usePermission();

  // get auth0 access token
  useEffect(() => {
    if (
      !Cookies.get("user_permission") ||
      !Cookies.get("aId") ||
      !Cookies.get("access_token")
    ) {
      if (!isLoading && isAuthenticated) {
        const getUserMetadata = async () => {
          try {
            const idToken = await getIdTokenClaims();
            const accessToken = idToken.__raw;

            Cookies.set("access_token", accessToken);
            setAccessToken(accessToken);
          } catch (e) {
            console.log(e.message);
          }
        };

        if (!accessToken) {
          getUserMetadata();
        }
      }
    }
  }, [user?.sub]);

  // get user role
  useEffect(() => {
    // refetch user role on first load
    if (Cookies.get("access_token")) {
      roleRefetch();
    }
  }, [accessToken]);

  // save user role as cookie
  useEffect(() => {
    if (roleData) {
      if (roleData.status == "failed") {
        logout({
          logoutParams: {
            returnTo: GETDANTE_URL,
          },
        });
      } else if (roleData.welcome) {
        logout({
          logoutParams: {
            returnTo: `${window.location.origin}/welcome?s=${roleData.welcome.status ?? ""
              }&n=${roleData.welcome.name ?? ""}`,
          },
        });
      } else {
        // logout if permissions differ from existing
        if (
          Cookies.get("user_permission") &&
          Cookies.get("user_permission") !== roleData.type?.join("-")
        ) {
          logout({
            logoutParams: {
              returnTo: `${window.location.origin}/auto-logout`,
            },
          });
        }

        Cookies.set("user_permission", roleData.type?.join("-"));
        Cookies.set("user_name", roleData.userName);
        Cookies.set("email", roleData.email);
        Cookies.set("manufacturer", roleData.manufacturer);
        setAccessToken(null);
        Cookies.set("aId", roleData.aId);
        Cookies.set("accountType", roleData?.accountType);
        Cookies.set("accountName", roleData?.manufacturer);
        Cookies.set("isMarketingNewsLetterRecipient", roleData?.isMarketingNewsLetterRecipient);
        Cookies.set("isEngineeringNewsLetterRecipient", roleData?.isEngineeringNewsLetterRecipient);
      }
    }
  }, [roleData]);

  if (error) {
    return <Navigate to="/restricted" replace={true} />;
  }

  if (!isLoading && !isAuthenticated) {
    Cookies.remove("user_permission");
    Cookies.remove("aId");
    Cookies.remove("user_name");
    Cookies.remove("email");
    Cookies.remove("manufacturer");
    Cookies.remove("access_token");
    Cookies.set("prevLocation", window.location.pathname);
    loginWithRedirect();
  }

  if ((isLoading || roleIsFetching) && showLoading) {
    return <Redirecting />;
  }

  if (
    isAuthenticated &&
    (Cookies.get("user_permission") || Cookies.get("user_permission") == "") &&
    Cookies.get("aId") &&
    Cookies.get("access_token")
  ) {
    return <Outlet />;
  }
};
